<template>
  <div class="menu">
    <ul class="unstyled">
      <li v-for="(item, index) in menuItems" :key="index">
        <router-link 
          :to="{ name: baseLink, params: { alias: item.alias } }" 
          :class="currentItem == item ? 'active' : null"
        >{{ item.title }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'projects-menu',
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    baseLink: {
      type: String,
      required: true
    },
    currentItem: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// ProjectsMenu.vue?eb87d278